import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Sidebar from './layout/Sidebar.tsx';

interface PageLayoutProps {
  children: React.ReactNode;
}

const MainContent = styled(Box)(({ theme }) => ({
  paddingLeft: '80px',
  paddingTop: theme.spacing(3),
  minHeight: '100vh',
  width: '100%',
  maxWidth: '100%',
  position: 'relative',
  zIndex: 1,
  '& > *': {
    width: '100%',
    maxWidth: '1800px',
    margin: '0 auto',
    padding: theme.spacing(3),
  },
}));

const PageLayout: React.FC<PageLayoutProps> = ({ children }) => {
  return (
    <>
      <Sidebar />
      <MainContent>
        {children}
      </MainContent>
    </>
  );
};

export default PageLayout; 